import React from 'react';
import { ModalContent, StyledModal, Title } from './StrikeZoneModalStyles';

interface IProps {
  closeHandler: () => void;
  visible: boolean;
}

const StrikeZoneModal: React.FC<IProps> = (props) => {
  const { closeHandler, visible } = props;
  return (
    <StyledModal
      title='Priority of strike zone dimension'
      open={visible}
      onClose={closeHandler}
      confirmBtn={{
        label: 'Got it',
        onClick: closeHandler,
      }}
    >
      <ModalContent>
        <div>The League will dictate which type of strike zone is used. The three types of strike zones are:</div>

        <div>
          <Title>1. Top and Bottom</Title>
          <div>
            This strike zone will represent the exact top and bottom of the strike zone per player. This is the highest priority SZ type
            unless the League associated with this session has indicated otherwise.
          </div>
        </div>
        <div>
          <Title>2. Height</Title>
          <div>
            This strike zone will take a percentage of a player’s height and calculate a strike zone based on the League’s requested
            percentages. The League can request different percentages for both the top and the bottom of the strike zone, but the default is
            57% of a player’s height for the top and 27% of a player’s height for the bottom.{' '}
          </div>
        </div>
        <div>
          <Title>3. Static</Title>
          <div>
            This strike zone will be a universal strike zone that is the same for every player. If a player does not have either an exact
            top and bottom or a height attached to their player profile, then this strike zone will be used.{' '}
          </div>
        </div>
      </ModalContent>
    </StyledModal>
  );
};

export default StrikeZoneModal;
